"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.placeFollowButton = void 0;
var React = require("react");
var classnames_1 = require("classnames");
exports.placeFollowButton = function (props) {
    if (props.showFollow)
        return null;
    var followClass = classnames_1.default([
        'o-btn',
        'c-building__action',
        {
            'o-btn--flat': props.followId !== -1,
        },
    ]);
    var text = props.followId > -1 ? props.t.unfollowPlace
        : props.t.followPlace + " " + props.followName;
    var followClicked = function () {
        if (props.followId === -1)
            return props.followClicked();
        return props.unfollowClicked();
    };
    var bellIconClass = classnames_1.default([
        'fal',
        {
            'fa-bell': props.followId === -1,
            'fa-bell-slash': props.followId > -1,
        },
    ]);
    return (React.createElement("button", { id: "prop-follow-btn", onClick: followClicked, className: followClass },
        React.createElement("span", { className: bellIconClass }),
        "\u00A0",
        text));
};
